//master controller
import { ModalController } from './ModalController.js';
//generic controller
import { AlertModalController } from './Generic/Controller/AlertModalController.js';
import { ConfirmModalController } from './Generic/Controller/ConfirmModalController.js';
import { LoadingModalController } from './Generic/Controller/LoadingModalController';
import { CancelModalController } from './Generic/Controller/CancelModalController.js';
//authen controller
import { OtpModalController } from './Authen/Controller/OtpModalController.js';
//redeem controller
import { ConfirmRedeemModalController } from './Redeem/ConfirmRedeem/ConfirmRedeemModalController.js';
import { SerialModalController } from './Redeem/Serial/SerialModalController.js';
import { ShippingAddressModalController } from './Redeem/ShippingAddress/ShippingAddressModalController.js';
import { QrModalController } from './Redeem/Qr/QrModalController.js';
//address controller
import { AddAddressModalController } from './Address/Add/AddAddressModalController.js';
import { EditAddressModalController } from './Address/Edit/EditAddressModalController.js';
import { ListAddressModalController } from './Address/List/ListAddressModalController.js';
import { AddTaxAddressModalController } from './Address/Add/AddTaxAddressModalController.js';
import { EditTaxAddressModalController } from './Address/Edit/EditTaxAddressModalController.js';
import { ListTaxAddressModalController } from './Address/List/ListTaxAddressModalController.js';

/**
 * Master ontroller
 * @method getModalController
 * Generic controller
 * @method getAlertModal
 * @method getConfirmModal
 * @method getLoadingModal
 * @method getCancelModal
 * Authen controller
 * @method getOtpModalController
 * Redeem controller
 * @method getConfirmRedeemModal
 * @method getSerialModal
 * @method getShippingAddressModal
 * @method getQrModal
 * Address controller
 * @method getAddAddressModal
 * @method getEditAddressModal
 * @method getListAddressModal
 * @method getAddTaxAddressModal
 * @method getEditTaxAddressModal
 * @method getListTaxAddressModal
 */
export default function ModalFactory() {
    this.modalController = new ModalController();

    // generic
    this.alertModal = null;
    this.confirmModal = null;
    this.loadingModal = null;
    this.cancelModal = null;
    // authen
    this.otpModal = null;
    // redeem
    this.confirmRedeemModal = null;
    this.serialModal = null;
    this.shippingAddressModal = null;
    this.QrModal = null;
    //address
    this.addAddressModal = null;
    this.editAddressModal = null;
    this.listAddressModal = null;
    this.addTaxAddtessModal = null;

    //#region generic
    this.getModalController = function() {
        return this.modalController;
    };
    this.getAlertModal = function() {
        this.alertModal = new AlertModalController();
        this.modalController.setAlertModal(this.alertModal);
        return this.alertModal;
    };
    this.getConfirmModal = function() {
        this.confirmModal = new ConfirmModalController();
        this.modalController.setConfirmModal(this.confirmModal);
        return this.confirmModal;
    };
    
    this.getCancelModal = function() {
        this.cancelModal = new CancelModalController();
        this.modalController.setCancelModal(this.cancelModal);
        return this.cancelModal;
    };

    this.getLoadingModal = function() {
        this.loadingModal = new LoadingModalController();
        this.modalController.setLoadingModal(this.loadingModal);
        return this.loadingModal;
    };
    //#endregion generic

    //#region authen
    this.getOtpModalController = function() {
        this.otpModal = new OtpModalController();
        this.modalController.setOtpModal(this.otpModal);
        return this.otpModal;
    };
    //#endregion authen

    //#region redeem
    this.getConfirmRedeemModal = function () {
        this.confirmRedeemModal = new ConfirmRedeemModalController();
        this.modalController.setConfirmRedeemModal(this.confirmRedeemModal);
        return this.confirmRedeemModal;
    };
    this.getSerialModal = function () {
        this.serialModal = new SerialModalController();
        this.modalController.setSerialModal(this.serialModal);
        return this.serialModal;
    };
    this.getShippingAddressModal = function () {
        this.shippingAddressModal = new ShippingAddressModalController();

        if (this.alertModal) {
            this.shippingAddressModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.shippingAddressModal.setLoadingModal(this.loadingModal);
        }

        this.modalController.setShippingAddressModal(this.shippingAddressModal);
        return this.shippingAddressModal;
    };
    this.getQrModal = function() {
        this.QrModal = new QrModalController();
        this.modalController.setQrModal(this.QrModal);
        return this.QrModal;
    };
    //#endregion redeem

    //#region address
    this.getAddAddressModal = function() {
        this.addAddressModal = new AddAddressModalController();

        if (this.alertModal) {
            this.addAddressModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.addAddressModal.setLoadingModal(this.loadingModal);
        }

        this.modalController.setAddAddressModal(this.addAddressModal);
        return this.addAddressModal;
    };
    this.getEditAddressModal = function() {
        this.editAddressModal = new EditAddressModalController();

        if (this.alertModal) {
            this.editAddressModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.editAddressModal.setLoadingModal(this.loadingModal);
        }

        this.modalController.setEditAddressModal(this.editAddressModal);
        return this.editAddressModal;
    };
    this.getListAddressModal = function() {
        this.listAddressModal = new ListAddressModalController();

        if (this.alertModal) {
            this.listAddressModal.setAlertModal(this.alertModal);
        }
        if (this.confirmModal) {
            this.listAddressModal.setConfirmModal(this.confirmModal);
        }
        if (this.loadingModal) {
            this.listAddressModal.setLoadingModal(this.loadingModal);
        }
        this.listAddressModal.setAddAddressModal(this.addAddressModal);
        this.listAddressModal.setEditAddressModal(this.editAddressModal);

        this.modalController.setListAddressModal(this.listAddressModal);
        return this.listAddressModal;
    };

    this.getAddTaxAddressModal = function() {
        this.addTaxAddressModal = new AddTaxAddressModalController();

        if (this.alertModal) {
            this.addTaxAddressModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.addTaxAddressModal.setLoadingModal(this.loadingModal);
        }

        this.modalController.setAddTaxAddressModal(this.addTaxAddressModal);
        return this.addTaxAddressModal;
    };

    this.getEditTaxAddressModal = function() {
        this.editTaxAddressModal = new EditTaxAddressModalController();

        if (this.alertModal) {
            this.editTaxAddressModal.setAlertModal(this.alertModal);
        }
        if (this.loadingModal) {
            this.editTaxAddressModal.setLoadingModal(this.loadingModal);
        }

        this.modalController.setEditTaxAddressModal(this.editTaxAddressModal);
        return this.editTaxAddressModal;
    };

    this.getListTaxAddressModal = function() {
        this.listTaxAddressModal = new ListTaxAddressModalController();

        if (this.alertModal) {
            this.listTaxAddressModal.setAlertModal(this.alertModal);
        }
        if (this.confirmModal) {
            this.listTaxAddressModal.setConfirmModal(this.confirmModal);
        }
        if (this.loadingModal) {
            this.listTaxAddressModal.setLoadingModal(this.loadingModal);
        }
        this.listTaxAddressModal.setAddTaxAddressModal(this.addTaxAddressModal);
        this.listTaxAddressModal.setEditTaxAddressModal(this.editTaxAddressModal);

        this.modalController.setListTaxAddressModal(this.listTaxAddressModal);
        return this.listTaxAddressModal;
    };
    //#endregion address
}
